import styled from 'styled-components';

import { PageContentContainer } from '../../styles/containers.sc';

export const PageContentContainerExt = styled(PageContentContainer)`
  padding: 30px;
`;

export const PlaceHolder = styled.div`
  height: 30px;
`;
